<template>
  <div id="guidelines">
    <h1>{{$t('map.transport.FAQ.title')}}</h1>
    <p>{{$t('map.transport.FAQ.directions')}}</p>
    <!-- Wysiwyg -->
    <div class="input-container">
      <!-- <label>{{$t("newAlert.alertBody")}}</label> -->
      <div class="wysiwyg">
        <Wysiwyg
          v-if="!wysiwygLoading"
          :placeholder="$t('map.transport.FAQ.placeholder')"
          :articleBody="delta"
          v-on:updateBody="body = $event"
        ></Wysiwyg>
      </div>
      <div class="error-msg">
        <span v-if="$v.body.$error">{{$t("map.transport.FAQ.errors.bodyRequired")}}</span>
      </div>
    </div>
    <button
      type="button"
      class="btn btn-dark control publish-btn"
      :disabled="isUploading"
      @click="validateForm"
    >{{$t('map.transport.FAQ.publish')}}</button>
  </div>
</template>

<script>
import apiService from "@/lib/api/FAQ.js";
import { required } from "vuelidate/lib/validators";
const Wysiwyg = () => import("@/components/Wysiwyg");

export default {
  components: {
    Wysiwyg
  },
  data: function() {
    return {
      wysiwygLoading: true,
      delta: null,
      body: null,
      isUploading: false
    };
  },
  validations: {
    body: {
      required
    }
  },
  beforeMount: async function() {
    await this.getFAQ();
  },
  methods: {
    getFAQ: async function() {
      this.$store.commit("global/SET_LOADING", true);
      const api = new apiService();
      try {
        const response = await api.getFAQ();
        this.delta = response.body;
        this.body = response.body;
        this.wysiwygLoading = false;
        this.$store.commit("global/SET_LOADING", false);
      } catch (error) {
        this.wysiwygLoading = false;
        this.$store.commit("global/SET_LOADING", false);
        this.delta = null;
        throw error;
      }
    },
    validateForm: async function() {
      this.isUploading = true;
      this.$v.$touch();
      if (this.$v.$error) {
        this.isUploading = false;
        return;
      }
      await this.postFAQ();
    },
    postFAQ: async function() {
      this.$store.commit("global/SET_LOADING", true);
      const api = new apiService();
      try {
        await api.postFAQ(
          this.body,
          this.$store.getters["session/userControl"]
        );
        this.$store.commit("global/SET_LOADING", false);
        this.isUploading = false;
        await this.getFAQ();
      } catch (error) {
        this.$store.commit("global/SET_LOADING", false);
        this.isUploading = false;
        throw error;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#guidelines {
  background-color: $white;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 2rem 4rem;

  .input-container {
    width: 100%;
  }

  .error-msg {
    color: $warn_red;
    font-size: 14px;
  }

  .publish-btn {
    align-self: flex-end;
    background: #000;
    border-radius: 0px;
    padding: 0.5rem 1rem;
  }
}
</style>

<style lang="scss">
#guidelines {
  .quill-editor .ql-editor {
    height: 50vh;
  }
}
</style>